import React, { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'

import horizontalBackground from '../../../assets/soft-toys.webp'
import { SectionText } from '../../../components/SectionText'
import { TableContent, TableRow } from '../../../components/TableRow'
import { formatBreakline } from '../../../utils/HTML-breakline-converter'

interface OfficeHoursProps {
    className?: string
}

export const OfficeHours: React.FC<OfficeHoursProps> = ({ className }) => {
    const { t } = useTranslation()
    const [noticeText, setNoticeText] = useState('')

    useEffect(() => {
        const vacationNotice = t('landingPage.officeHours.vacationNotice.message')
        if (vacationNotice) setNoticeText(vacationNotice)
    }, [t])

    const rowData = t('landingPage.officeHours.rows', { returnObjects: true }) as Array<{ day: string; hours: string }>

    const rowStyles = (index: number) => {
        switch (index) {
            case 0:
                return { classNameTr: 'sm:align-top', classNameTdLeft: 'pt-8 font-bold', classNameTdRight: 'pt-8' }
            case 1:
                return { classNameTr: 'sm:align-top sm:mt-2', classNameTdLeft: 'font-bold' }
            case 2:
                return { classNameTr: 'sm:align-top sm:mt-2', classNameTdLeft: 'font-bold' }
            case 3:
                return { classNameTr: 'sm:align-top sm:mt-2', classNameTdLeft: 'font-bold pr-10' }
            case 4:
                return { classNameTr: 'sm:align-top sm:mt-2', classNameTdLeft: 'font-bold' }
            case 5:
                return { classNameTr: 'align-top', classNameTdLeft: 'font-bold pt-5', classNameTdRight: 'pt-5' }
        }
    }
    const rowProperties: TableContent[] = rowData.map((row, index: number) => ({
        ...rowStyles(index),
        textColumnLeft: row.day,
        textColumnRight: (
            <div
                dangerouslySetInnerHTML={{
                    __html: formatBreakline(row.hours),
                }}
            />
        ),
    }))

    return (
        <div
            id="office-hours"
            className={`${className} flex justify-between min-h-[700px] h-auto w-full text-xl text-primary-blue-faded
                sm:min-h-[700px]
            `}>
            <div className="w-full h-full flex items-center justify-center relative">
                <img
                    src={horizontalBackground}
                    className="justify-center h-full w-full absolute object-cover object-top sm:object-right"
                    alt="background"
                />
                <div className="flex flex-col justify-center items-center bg-secondary-blue bg-opacity-80 z-10 h-full w-full py-20">
                    {noticeText && (
                        <div
                            className="h-1/2 w-1/2 text-xl font-bold text-primary-blue-faded flex flex-col justify-center items-center
                        sm:h-1/2 gap-2 pb-5">
                            {t('landingPage.officeHours.vacationNotice.title')} <br></br>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: formatBreakline(noticeText),
                                }}
                            />
                        </div>
                    )}
                    <SectionText
                        className="grid place-content-center max-w-[600px] w-1/2 h-full mx-auto
                        sm:px-5 sm:py-8 sm:w-full sm:h-auto"
                        title={t('landingPage.officeHours.title')}
                        hrLineColor="bg-white"
                        discoverMoreLink="about-me">
                        <p className="mb-6 text-center">{t('landingPage.officeHours.phoneConsultation')}</p>
                        <table>
                            {rowProperties.map((value, index) => {
                                return <TableRow key={index} TableRowProps={value} />
                            })}
                        </table>
                    </SectionText>
                </div>
            </div>
        </div>
    )
}
